import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { Button, ButtonVariantOption, SubmitButton } from "../Button";
import { useIsMobile } from "@/hooks/useIsMobile";

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  onSubmit: (cancelLoading: () => void) => void;
  title?: string;
  description: string;
  secondaryDescription?: string;
  submitLabel?: string;
}

/**
 * 検索実行前の共通確認ダイアログ
 */
export const ConfirmDialogSearch: React.FC<Props> = (props) => {
  const {
    open,
    setOpen,
    loading,
    onSubmit,
    title = "確認画面",
    description,
    secondaryDescription = "件数が多い場合、検索完了まで時間がかかります。",
    submitLabel = "検索する",
  } = props;
  const isMobile = useIsMobile();

  return (
    <Dialog
      open={open}
      fullScreen={isMobile}
      onClose={(_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
        {secondaryDescription && (
          <DialogContentText>{secondaryDescription}</DialogContentText>
        )}
      </DialogContent>
      {/* 共通 Button は SP で幅100%になるため、内容幅で包む */}
      <DialogActions>
        <Box sx={{ width: "fit-content" }}>
          <Button
            variant={ButtonVariantOption.Outlined}
            onClick={() => {
              setOpen(false);
            }}
            label={"キャンセル"}
            disabled={loading}
          />
        </Box>
        <Box sx={{ width: "fit-content" }}>
          <SubmitButton
            variant={ButtonVariantOption.Contained}
            onClick={(_event, cancelLoading) => {
              onSubmit(cancelLoading);
            }}
            label={submitLabel}
            timeout={30000}
            disabled={loading}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};
